import axios from '../../utils/axiosConfig';
import { Contexture } from './Contexture';

const BASE_URL = `${process.env.REACT_APP_LAMBDA_API_URL}/contexture/auth`;

export class Auth {
  static async getUserInfo() {
    try {
      const response = await axios.get(`${BASE_URL}/userinfo`, {
        headers: Contexture.getHeaders(),
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async getTenants() {
    try {
      const response = await axios.get(`${BASE_URL}/tenants`, {
        headers: Contexture.getHeaders(),
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }
}
